var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.583333,
    y: 0.583333,
    width: 40.8333,
    height: 40.8333,
    rx: 5.41667,
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 1.16667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 31.7595C19.9104 31.7595 18.8304 31.4395 17.9804 30.8095L13.6804 27.5995C12.5404 26.7495 11.6504 24.9695 11.6504 23.5595V16.1195C11.6504 14.5795 12.7804 12.9395 14.2304 12.3995L19.2204 10.5295C20.2104 10.1595 21.7704 10.1595 22.7604 10.5295L27.7504 12.3995C29.2004 12.9395 30.3304 14.5795 30.3304 16.1195V23.5495C30.3304 24.9695 29.4404 26.7395 28.3004 27.5895L24.0004 30.7994C23.1704 31.4395 22.0904 31.7595 21.0004 31.7595ZM19.7504 11.9395L14.7604 13.8095C13.9104 14.1295 13.1604 15.2095 13.1604 16.1295V23.5595C13.1604 24.5095 13.8304 25.8395 14.5804 26.3995L18.8804 29.6095C20.0304 30.4695 21.9704 30.4695 23.1304 29.6095L27.4304 26.3995C28.1904 25.8295 28.8504 24.5095 28.8504 23.5595V16.1195C28.8504 15.2095 28.1004 14.1295 27.2504 13.7995L22.2604 11.9295C21.5804 11.6895 20.4204 11.6895 19.7504 11.9395Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6602 23.2301C19.4702 23.2301 19.2802 23.1601 19.1302 23.0101L17.5202 21.4001C17.2302 21.1101 17.2302 20.6301 17.5202 20.3401C17.8102 20.0501 18.2902 20.0501 18.5802 20.3401L19.6602 21.4201L23.4302 17.6501C23.7202 17.3601 24.2002 17.3601 24.4902 17.6501C24.7802 17.9401 24.7802 18.4201 24.4902 18.7101L20.1902 23.0101C20.0402 23.1601 19.8502 23.2301 19.6602 23.2301Z",
    fill: "#6F8EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityTick);
export default __webpack_public_path__ + "static/media/security-tick.a092361055225cac494bb223aa779de6.svg";
export { ForwardRef as ReactComponent };